import { useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

const PageTransition = ({ children }) => {
  const location = useLocation();
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    setVisible(false);
    const timeout = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timeout);
  }, [location.pathname]);

  return (
    <div
      className={`min-w-0 transition-opacity duration-150 ease-in-out ${visible ? 'opacity-100' : 'opacity-0'}`}
      aria-busy={!visible}
    >
      {children}
    </div>
  );
};

export default PageTransition;
